import { Theme, css } from '@emotion/react';

export const chipStyles = (theme: Theme) =>
  css({
    height: '25px',
    width: '50px',
    backgroundColor: theme.colors.semanticOrange,
    border: 'none',
  });
